import React, { useState, useEffect } from 'react';
import './SearchSettings.css';
import { FaTimes } from 'react-icons/fa';
import { useAppContext } from '../../context/AppContext';
import { useTranslation } from 'react-i18next';

const SearchSettings = ({ isOpen, closeSettings, onApply, defaultSettings }) => {
    const { t } = useTranslation();

    // checkbox kontrol ediliyor.
    const [isChecked, setIsChecked] = useState(false);
    function handleCheckBox(e) {
        const checked = e.target.checked;
        setIsChecked(checked);
        setTempSettings(prevSettings => ({
            ...prevSettings,
            mode: checked ? "table" : "text"
        }));
    }
    const currentYear = new Date().getFullYear();
    const { token } = useAppContext();
    const [settingsData, setSettingsData] = useState({
        tur: [],
        citation_format: [],
        section: [],
        searchScope: [],
        pageSize: [],
        articleOrder: [],
        language: [],
        discipline: [],
    });

    const [tempSettings, setTempSettings] = useState({
        tur: '',
        citationFormat: '',
        section: '',
        language: '',
        "pageSize": '',
        "articleOrder": '',
        discipline: [],
        startYear: currentYear - 64,
        endYear: currentYear,
        mode: "text"
    });

    useEffect(() => {
        const fetchData = async () => {

            try {
                const response = await fetch('https://ai.kesifaraci.com/service/api/searchsettings', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({})
                });

                const result = await response.json();

                if (result.result) {
                    setSettingsData(result.data);
                    // Tüm alanlar için ilk değerleri otomatik olarak seç
                    /*setTempSettings({
                        tur: result.data.tur[0]?.alias || '',
                        citationFormat: result.data.citation_format[0]?.alias || '',
                        section: result.data.section[1]?.alias || '',
                        language: result.data.language[1]?.alias || '',
                        discipline: result.data.discipline[0]?.alias || '',
                        startYear: currentYear - 64,
                        endYear: currentYear,
                    });*/
                    setTempSettings(defaultSettings);
                    // isChecked ayarlaması burda yapılıyor.
                    if (defaultSettings.mode === "table") {
                        setIsChecked(true);
                    }
                    else if (defaultSettings.mode === "text") {
                        setIsChecked(false);
                    }
                }
            } catch (error) {
                console.error('Veri çekme hatası:', error);
            }
        };

        fetchData();
    }, []);



    const generateYearOptions = () => {
        const years = [];
        for (let year = currentYear; year >= 1900; year--) {
            years.push(year);
        }
        return years;
    };

    const handleApply = () => {
        onApply(tempSettings);
        closeSettings();
    };

    // Temizle fonksiyonunu da güncelle - varsayılan değerlere dönsün
    const handleClear = () => {
        if (settingsData.tur?.length > 0) {
            setTempSettings({
                tur: settingsData.tur[0]?.alias || '',
                citationFormat: settingsData.citation_format[0]?.alias || '',
                section: settingsData.section[1]?.alias || '',
                language: settingsData.language[1]?.alias || '',
                discipline: settingsData.discipline[0]?.alias || '',
                //tarama seçenekleri temizlenmiyor.
                startYear: currentYear - 64,
                endYear: currentYear
            });
        }
    };

   // console.log(tempSettings)

    return (
        <div className={`search-settings ${isOpen ? 'open' : 'closed'}`}>
            <button className="close-button" onClick={closeSettings}>
                <FaTimes />
            </button>
            <div className="settings-container">
                <div className="row">
                    <div className="input-group">
                        <label>{t('Yayın Türü')}</label>
                        <select
                            value={tempSettings.tur}
                            onChange={(e) => setTempSettings({ ...tempSettings, tur: e.target.value })}
                        >
                            {settingsData.tur?.map((item, index) => (
                                <option key={index} value={item.alias}>
                                    {t(item.title)}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="input-group">
                        <label>{t('Yayın Bölümü')}</label>
                        <select
                            value={tempSettings.section}
                            onChange={(e) => setTempSettings({ ...tempSettings, section: e.target.value })}
                        >
                            {settingsData.section?.map((item, index) => (
                                <option key={index} value={item.alias}>
                                    {t(item.title)}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="input-group">
                        <label>{t('Yayın Disiplini')}</label>
                        <select
                            multiple
                            value={tempSettings.discipline}
                            onChange={(e) => {
                                const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                                setTempSettings({ ...tempSettings, discipline: selectedOptions });
                            }}
                        >
                            {settingsData.discipline?.map((item, index) => (
                                <option key={index} value={item.alias}>
                                    {t(item.title)}
                                </option>
                            ))}
                        </select>
                    </div>


                    <div className="input-group">
                        <label>{t('Yayın Yazı Dili')}</label>
                        <select
                            value={tempSettings.language}
                            onChange={(e) => setTempSettings({ ...tempSettings, language: e.target.value })}
                        >
                            {settingsData.language?.map((item, index) => (
                                <option key={index} value={item.alias}>
                                    {t(item.title)}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="input-group">
                        <label>{t('Kaynakça Formatı')}</label>
                        <select
                            value={tempSettings.citationFormat}
                            onChange={(e) => setTempSettings({ ...tempSettings, citationFormat: e.target.value })}
                        >
                            {settingsData.citation_format?.map((item, index) => (
                                <option key={index} value={item.alias}>
                                    {item.title}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="input-group">
                        <label>{t('Yıl Aralığı')}</label>
                        <div className="year-input-group">
                            <select
                                value={tempSettings.startYear}
                                onChange={(e) => setTempSettings({
                                    ...tempSettings,
                                    startYear: parseInt(e.target.value)
                                })}
                            >
                                {generateYearOptions().map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                            <select
                                value={tempSettings.endYear}
                                onChange={(e) => setTempSettings({
                                    ...tempSettings,
                                    endYear: parseInt(e.target.value)
                                })}
                            >
                                {generateYearOptions().map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="input-group">
                    <label>{t('Tarama Seçenekleri')}</label>
                    <select
                        value={tempSettings.searchScope} // Yeni bir state alanı
                        onChange={(e) => setTempSettings({ ...tempSettings, searchScope: e.target.value })}
                    >
                        <option value="all">{t('Tüm Kaynaklarda Tara')}</option>
                        <option value="subscribed">{t('Abone Veri Tabanlarında ve Seçkin Açık Erişim Kaynaklarda Tara')}
                        </option>
                        <option value="onlysubscribed">{t('Sadece Abone Veri Tabanlarında Tara')}</option>
                        <option value="indexed">{t('Indeksli Yayınlarda Tara')}</option>
                        <option value="open_access">{t('Sadece Açık Erişim Veri Tabanlarında Tara')}</option>
                    </select>
                </div>
                <div className="row">
                    <div className="input-group">


                        <label>{t('Metin Uzunluğu')}</label>
                        <select
                            value={tempSettings.pageSize} // Yeni bir state alanı
                            onChange={(e) => setTempSettings({ ...tempSettings, pageSize: e.target.value })}
                        >
                            <option value="1">{t('Normal (1 Sayfa - 30sn)')}</option>
                            <option value="2">{t('Uzun (2 Sayfa - 45sn)')}</option>
                            <option value="4">{t('Çok Uzun (3-4 Sayfa - 75sn)')}</option>
                        </select>
                    </div>
                    <div className="input-group">
                        <label>{t('Sıralama Seçenekleri')}</label>
                        <select
                            value={tempSettings.articleOrder} // Yeni bir state alanı
                            onChange={(e) => setTempSettings({ ...tempSettings, articleOrder: e.target.value })}
                        >
                            <option value="auto">{t('Otomatik - Dengeli')}</option>
                            <option value="uptodate">{t('En Güncel Yayınlar')}</option>
                            <option value="landmark">{t('En Saygın Yayınlar')}</option>
                        </select>
                    </div>
                </div>
                <div className='table-content-main-div'>
                    <label>{t('Mod Seçenekleri')} </label>
                    <div className='table-content-checkbox-div'>
                        <input checked={isChecked} onChange={handleCheckBox} type="checkbox" />
                    </div>
                    <div className='table-content-label-div'>
                        <label>{t('Tablo Modu')}</label>
                    </div>
                </div>

                <div className="actions">
                    <button className="btn-clear" onClick={handleClear}>
                        {t('Temizle')}
                    </button>
                    <button onClick={handleApply} className="btn-apply">{t('Uygula')}</button>
                </div>
            </div>
        </div>
    );
};

export default SearchSettings;